module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
    staticClass: "content-wrapper column centered-start",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "column centered-start gerenciador-log-container"
  }, [_c('div', {
    staticClass: "column all-start log-title-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Última atualização: " + _vm._s(_vm.ultimaAtualizacao) + "\n          ")])]), _vm._v(" "), _c('b-container', {
    staticClass: "table-log-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    key: _vm.tableDataKey,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": true,
      "items": _vm.table.items,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "title": '<h5> Encerra Sessão de Edição. </h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.encerraSessao(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-close",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }, {
      key: "ultimo_ping",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }], null, false, 53862275)
  }), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-total-documentos"
  }, [_c('div', [_vm._v("\n                    Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.table.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "log-title row-flex centered-start"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Logs de Edição de Proposta\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0162948c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/GerenciadorEdicaoLog.vue
// module id = 1842
// module chunks = 1